import React from "react";
import { CheckCircle, Building2, Settings, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
    "Optimized for compact urban spaces",
    "Both horizontal and vertical car movement",
    "Independent access to each vehicle",
    "No pit required – suitable for surface installation",
    "Ideal for residential & commercial projects",
];

const applications = [
    "Residential Apartments",
    "Corporate Office Buildings",
    "Shopping Malls",
    "Hospitals & Hotels",
    "Private Bungalows with limited parking",
];

const PuzzleParkingDetail = () => {
    const navigate = useNavigate()
    return (
        <section className="about-wrapper">
            {/* Hero */}
            <div className="about-hero">
                <div className="hero-content">
                    <h1>Puzzle Parking System</h1>
                    <p>
                        A smart and modular parking solution that enables cars to move both vertically and horizontally — maximizing space without compromising convenience.
                    </p>
                </div>
            </div>

            {/* Description */}
            <div className="about-section">
                <h2>What is Puzzle Parking?</h2>
                <p>
                    Puzzle parking is a semi-automated car parking system designed for high-density urban environments where space is at a premium. The system arranges cars in a matrix of vertical and horizontal platforms. Using an intelligent control system, the required platform automatically moves to ground level for car retrieval or parking — without affecting other vehicles.
                </p>
                <p>
                    It provides maximum space utilization, allows independent access to every vehicle, and supports both above-ground and underground installations depending on the site requirements.
                </p>
            </div>

            {/* Features */}
            <div className="about-section">
                <h2>Key Features & Benefits</h2>
                <ul className="lt-puzzle-list">
                    {features.map((item, index) => (
                        <li key={index}><CheckCircle size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* How it Works */}
            <div className="about-section">
                <h2>How It Works</h2>
                <p>
                    Vehicles are parked on steel platforms arranged in grids. The system software calculates the movement path to bring the desired platform to the entry level by shifting other platforms up, down, or sideways. A combination of motors, pulleys, and chains ensures smooth and safe transitions.
                </p>
                <p>
                    Depending on the configuration, puzzle systems can offer 2 to 6 levels with various entry-exit strategies. Safety sensors, limit switches, and PLC logic are embedded to ensure high operational safety.
                </p>
            </div>

            {/* Applications */}
            <div className="about-section">
                <h2>Best Suited For</h2>
                <ul className="lt-puzzle-list">
                    {applications.map((item, index) => (
                        <li key={index}><Building2 size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* Call to Action */}
            <div className="lt-puzzle-cta">
                <div className="lt-puzzle-cta-content">
                    <h3>Need Puzzle Parking for your building?</h3>
                    <p>Contact LIFTECH ENGINEERING PVT. LTD. today for a site analysis or customized quote.</p>
                    <button className="lt-puzzle-contact-btn" onClick={() => navigate("/get-started")}>
                        <PhoneCall size={18} /> Request Consultation
                    </button>
                </div>
            </div>
        </section>
    );
};

export default PuzzleParkingDetail;
